module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drug-panel"
  }, [_c('div', {
    staticClass: "drug-panel--head"
  }, [_c('button', {
    staticClass: "btn btn-info icon-right",
    on: {
      "click": function($event) {
        _vm.createForm = true
      }
    }
  }, [_vm._v("新增藥物")]), (_vm.createForm) ? _c('CreateMedicineForm', {
    on: {
      "closeForm": _vm.closeForm
    }
  }) : _vm._e(), _c('form', {
    staticClass: "form-inline",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onFilterSet($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medName),
      expression: "medName"
    }],
    staticClass: "form-control mr-2",
    attrs: {
      "type": "text",
      "placeholder": "輸入藥碼, 學名或料位號"
    },
    domProps: {
      "value": (_vm.medName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.medName = $event.target.value
      }
    }
  }), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("搜尋")])])], 1), _c('vuetable', {
    ref: "vuetableMed",
    attrs: {
      "api-url": (_vm.server + "/api/medication/?type=normal"),
      "data-path": "results",
      "fields": _vm.fields,
      "http-options": _vm.httpOptions,
      "pagination-path": "",
      "css": _vm.boostrapCss,
      "perPage": 30,
      "detail-row-component": "drug-settings-detail",
      "append-params": _vm.moreParams
    },
    on: {
      "vuetable:pagination-data": _vm.onPaginationData,
      "vuetable:cell-clicked": _vm.onMedClicked
    }
  }), _c('vuetable-pagination', {
    ref: "pagination",
    attrs: {
      "css": _vm.boostrapCss.pagination
    },
    on: {
      "vuetable-pagination:change-page": _vm.onChangePage
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a0fa0a60","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/SystemSettings/DrugDBSettings.vue
// module id = 1532
// module chunks = 1